import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Button, DialogActions, DialogContent, Paper, Stack, TextField, Typography } from '@mui/material';
import { api, ui, state } from '../../../../../../interfaces/interfaces';
import { fetchAgain } from '../EnquiryTabs/index';
import { removeLock } from '..';
import { useAppSelector } from "@store/hooks";

const handleClose = () => {
    ui.CallMeBackAuthDialogModal = false
    ui.CallMeBackAuthValue = ''
};
const handleCallMeBackAuth = async (password: string, setHelperText: any) => {
    const result = await api.fetchCheckCallMeBackAuthorization({ password })
    if (result && result.length > 0) {
        const isMatch = result[0] && result[0].id && result[0].id > 0

        if (isMatch) {
            // request cancellation
            await api.fetchGetCallMeBackCancel({ leadId: ui.CallMeBacksModalData.leadId, userId: state.UserId, contactCustomer: false })
            await fetchAgain()
            ui.CallMeBacksModal = false;
            removeLock();
            handleClose()
        }
        else {
            setHelperText('Incorrect password')
        }
    }
};

type Props = {
}

const CallMeBackAuthDialog: React.FC<Props> = () => {
    const CallMeBackAuthDialogModal = useAppSelector(({ ui }) => ui.CallMeBackAuthDialogModal);
    const [password, setPassword] = React.useState('');
    const [helperText, setHelperText] = React.useState('');

    return (
        (<Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={CallMeBackAuthDialogModal} maxWidth="sm" fullWidth>
            <DialogTitle id="simple-dialog-title">Please provide authorization password</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2}>
                    <Paper elevation={4}>
                        <Typography variant="body1" sx={{ fontWeight: "bold", p: 1 }}> <TextField
                            id="auth-call-me-back-local"
                            label="Authorisation Password"
                            type="text"
                            // defaultValue="2017-05-24T10:30"
                            sx={{ width: 250 }}
                            helperText={helperText}
                            error={helperText !== ''}
                            onChange={(e) => { setPassword(e.target.value); helperText !== '' && setHelperText('') }}
                            value={password}
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                }
                            }}
                        /></Typography>
                    </Paper>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button color='success' variant='outlined' onClick={handleClose}>Close</Button>
                <Button color='secondary' variant='contained' onClick={() => { (handleCallMeBackAuth(password, setHelperText)) }}>Cancel</Button>
            </DialogActions>
        </Dialog >)
    );
}

export default React.memo(CallMeBackAuthDialog);